import React from "react";
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";

const BillingConsolidatedInvoiceTable = ({ data }) => {

  //For adding Serial number
  const bodyData = data?.body?.map((bodyValue, index) => ({...bodyValue, 'Sr. No.': index + 1}));

  return (
    <Box className="billingConsolidatedTable mb40">
      <TableContainer>
        <Table>
          <TableHead className="tableHeader commonBorder">
            <TableRow className="tableHeaderRow commonBorder">
              {data?.headers?.map((ele, index) => (
                <TableCell
                  component="th"
                  scope="row"
                  className="commonBorder"
                  key={index}
                >
                  <Typography
                    variant="body6"
                    component={"p"}
                    className="colorSolidBlack"
                  >
                    {ele.label}
                  </Typography>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody className="commonBorder">
            {bodyData?.length > 0 &&
              bodyData?.map((bodyValue, index) => (
                <TableRow className="tableHeaderRow" key={index}>
                  {data?.headers?.map((headerKey, idk) => (       
                    <TableCell
                      component="th"
                      scope="row"
                      className="commonBorder"
                      key={idk}
                    >
                      <Typography
                        variant={"body6"}
                        component={"p"}
                        className="colorSolidBlack textCenter"
                      >
                        {bodyValue?.[headerKey?.label === "Sr. No." ? headerKey?.label : headerKey?.key]}
                      </Typography>            
                    </TableCell>
                  ))}
                </TableRow>
              ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default BillingConsolidatedInvoiceTable;
